module.exports = __webpack_public_path__ + "img/Vet_TibiaWithPlates.af7c649a.jpg";